export default "__VITE_ASSET__23b29ef5__"